// extracted by mini-css-extract-plugin
export default {"dashTrialSmallTooltip":"DashTrialCTA_dashTrialSmallTooltip__ph+kt"};